import React, { createContext, useContext, useEffect, useReducer } from "react";
import SearchContext from "./SearchContext";
import { StoreContext } from "./StoreContext";
const localData = JSON.parse(localStorage.getItem("userInfo"));

const UserContext = createContext({
  userInfo: [],
  isContactPopupShow: false,
  isLocationPopupShow: false,
  isOrderPopupShow: false,
  isHomePage: true,
  updateUser: (value) => { },
  updateLocation: (value) => { },
  showContactPopup: () => { },
  showLocationPopup: () => { },
  goToOrderPage: () => { },
  goToHomePage: () => { },
  closeAllPopups: () => { },
  isEmptyCartPopupShow: false,
  showEmptyCartPopup: () => { },
});

const initialState = {
  userInfo: localData || {},
  isContactPopupShow: false,
  isLocationPopupShow: false,
  isOrderPopupShow: false,
  isHomePage: true,
  isEmptyCartPopupShow: false,
};

const UserReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_USER":
      return {
        ...state,
        userInfo: { ...state.userInfo, ...action.value },
      };
    case "UPDATE_LOCATION":
      return {
        ...state,
        userInfo: { ...state.userInfo, location: action.value },
        isLocationPopupShow: false,
      };
    case "SHOW_CONTACT_POPUP":
      return { ...state, isContactPopupShow: true, isLocationPopupShow: false, isOrderPopupShow: false, isEmptyCartPopupShow: false };
    case "SHOW_LOCATION_POPUP":
      return { ...state, isLocationPopupShow: true, isContactPopupShow: false, isOrderPopupShow: false, isEmptyCartPopupShow: false };
    case "GO_TO_ORDER_PAGE":
      return { ...state, isOrderPopupShow: true, isHomePage: false, isContactPopupShow: false, isLocationPopupShow: false, isEmptyCartPopupShow: false };
    case "GO_TO_HOME_PAGE":
      return { ...state, isHomePage: true, isOrderPopupShow: false, isContactPopupShow: false, isLocationPopupShow: false, isEmptyCartPopupShow: false };
    case "CLEAR_USER":
      return { ...state, userInfo: {} };
    case "SHOW_EMPTY_CART_POPUP":
      return { ...state, isEmptyCartPopupShow: true, isContactPopupShow: false, isOrderPopupShow: false, isLocationPopupShow: false };
    case "CLOSE_ALL_POPUPS":
      return {
        ...state,
        isContactPopupShow: false,
        isLocationPopupShow: false,
        isOrderPopupShow: false,
        isEmptyCartPopupShow: false,
      };
    default:
      return state;
  }
};

export const UserContextProvider = ({ children }) => {
  const [user, dispatchUserAction] = useReducer(UserReducer, initialState);
  const searchCtx = useContext(SearchContext);
  const { isLocalClear } = useContext(StoreContext);

  const showEmptyCartPopup = () => dispatchUserAction({ type: "SHOW_EMPTY_CART_POPUP" });
  const updateUser = (value) => dispatchUserAction({ type: "UPDATE_USER", value });
  const updateLocation = (value) => dispatchUserAction({ type: "UPDATE_LOCATION", value });
  const showContactPopup = () => dispatchUserAction({ type: "SHOW_CONTACT_POPUP" });
  const showLocationPopup = () => dispatchUserAction({ type: "SHOW_LOCATION_POPUP" });
  const goToOrderPage = () => dispatchUserAction({ type: "GO_TO_ORDER_PAGE" });
  const goToHomePage = () => dispatchUserAction({ type: "GO_TO_HOME_PAGE" });
  const closeAllPopups = () => dispatchUserAction({ type: "CLOSE_ALL_POPUPS" });

  useEffect(() => {
    if (user.isOrderPopupShow || user.isContactPopupShow || user.isLocationPopupShow) {
      document.body.classList.add("popup-opned");
    } else {
      document.body.classList.remove("popup-opned");
    }
  }, [user.isOrderPopupShow, user.isContactPopupShow, user.isLocationPopupShow]);

  useEffect(() => {
    if (isLocalClear) {
      dispatchUserAction({ type: "CLEAR_USER" });
    }
  }, [isLocalClear]);

  // useEffect(() => {
  //   if (user.isContactPopupShow || user.isLocationPopupShow || user.isOrderPopupShow) {
  //     if (searchCtx.isSearchEnabel) {
  //       searchCtx.disableSearch();
  //     }
  //   } else {
  //     if (searchCtx.searchValue !== "") {
  //       searchCtx.updateSearch("");
  //     }
  //   }
  // }, [
  //   user.isContactPopupShow,
  //   user.isLocationPopupShow,
  //   user.isOrderPopupShow,
  //   searchCtx.isSearchEnabel,
  //   searchCtx.searchValue
  // ]);


  const userContext = {
    userInfo: user.userInfo,
    isContactPopupShow: user.isContactPopupShow,
    isLocationPopupShow: user.isLocationPopupShow,
    isOrderPopupShow: user.isOrderPopupShow,
    isHomePage: user.isHomePage,
    isEmptyCartPopupShow: user.isEmptyCartPopupShow,
    showEmptyCartPopup,
    updateUser,
    updateLocation,
    showContactPopup,
    showLocationPopup,
    goToOrderPage,
    goToHomePage,
    closeAllPopups,
  };

  useEffect(() => {
    localStorage.setItem("userInfo", JSON.stringify(user.userInfo));
  }, [user.userInfo]);

  return <UserContext.Provider value={userContext}>{children}</UserContext.Provider>;
};

export default UserContext;